/**
 * An enum representing sort order
 */
export enum Sort {
  /** Sort ascending */
  Ascending,

  /** Sort descending */
  Descending
}
